import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';

import { DataService } from '../data.service';
import { modelMenu } from '../../model/menu'

@Component({
  selector: 'app-info-usuario',
  templateUrl: './info-usuario.component.html',
  styleUrls: ['./info-usuario.component.css']
})
export class InfoUsuarioComponent implements OnInit {
  theme:string="";
  errMsg:string="";
  okMsg:string = "";
  modMenu:modelMenu[]=[];
  @Input() usrN:string="";

constructor(private dataService: DataService, private router:Router) { }

  ngOnInit() {
    this.usrN = sessionStorage.getItem('sisDVDusrN');
    this.dataService.getMenUser().subscribe(
                            rows => {   
                                    this.modMenu= <any>rows
                                    },          
                            error => this.errMsg = <any>error,
                            () => this.fnMenuCargado());         
  }

  fnMenuCargado(){
    console.log(this.modMenu);
    var auxMenu;
    setTimeout(() => {
      for(var i=1; i<=this.modMenu.length; i++){
        auxMenu = document.getElementById("divItemImagenUser_"+this.modMenu[i-1].a);
        if(this.modMenu[i-1].i)
          auxMenu.style.backgroundImage = "url('/assets/imgs/hup/" + this.modMenu[i-1].i + "')";
      }      
    }, 15);
  }

  fnMuestraMenu(menu){
    if(menu.style.visibility=="hidden")
      menu.style.visibility = "visible";
    else
      menu.style.visibility = "hidden";

  }

  fnClickUserMenuItem(i){
    //console.log(i);
    if(i.a=='logout')
      this.fnLogOut();
    else
      this.router.navigate([i.a]);
  }

  fnLogOut(){
      //console.log("LogOut")
      sessionStorage.removeItem('sisDVDlog');
      sessionStorage.removeItem('sisDVDusr');
      sessionStorage.removeItem('sisDVDusrN');
      sessionStorage.removeItem('sisDVDusrR');
      sessionStorage.removeItem('sisDVDusrM');    
      sessionStorage.removeItem('sisDVDusrFAP');
      this.router.navigate(['login']);
  }

}
